﻿import React, { useEffect } from "react";
import { SmartToolsRoot } from "../";

export interface IFileUploadProps {
    fileLoadCallback: (file: File) => void;
}

export const FileUpload: React.FunctionComponent<IFileUploadProps> = (
    props,
): React.ReactElement => {
    useEffect(() => {
        window.addEventListener(`drop`, preventDefaultAction);
        window.addEventListener(`dragover`, preventDefaultAction);

        return (): void => {
            window.removeEventListener(`drop`, preventDefaultAction);
            window.removeEventListener(`dragover`, preventDefaultAction);
        };
    }, []);

    const preventDefaultAction = (e: Event): void => {
        e.preventDefault();
    };

    const callbackWrapper = (file: File): void => {
        if (file.size <= 8000000) {
            props.fileLoadCallback(file);
        } else {
            SmartToolsRoot.showMessage(`The maximum filesize is 8MB.`);
        }
    };

    const dropHander = (e: React.DragEvent<HTMLFormElement>): void => {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
            const file: File = e.dataTransfer.files[i];

            callbackWrapper(file);
        }
    };

    const dialogHandler = (
        input: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        for (let i = 0; i < input.target.files.length; i++) {
            const file: File = input.target.files[i];

            callbackWrapper(file);
        }
    };

    return (
        <form
            className={`fileupload-container`}
            encType={`multipart/formdata`}
            onDrop={dropHander}
        >
            <div className={`fileupload`}>
                <img src={`/Images/UI/UploadIcon.svg`} />
                <input
                    accept={`image/*,.pdf`}
                    className={`fileupload-input`}
                    id={`fileupload-input`}
                    onChange={dialogHandler}
                    type={`file`}
                />
                <label
                    className={`fileupload-label`}
                    htmlFor={`fileupload-input`}
                >
                    <div>
                        DRAG JPG/PNG OR CSV FILE HERE <br /> OR{" "}
                        <div className={`anchortag`}>BROWSE</div>
                    </div>
                </label>
                <p>The maximum file size is 8MB</p>
            </div>
        </form>
    );
};
